module.exports = __webpack_public_path__ + "img/kakie_banner_1920x720-min.a7e87ddc.jpg";